import Member from './Member';
import withHandlers from 'recompose/withHandlers';
import { 
  trackFamilyMembersRemove, 
  trackFamilyMembersChanged,
  trackFamilyMembersDeleteAll 
} from 'src/client/js/analytics/category/product';


const enhance = withHandlers({
  onChange: props => e => {
    const value = e.target.value;
    if (!value) {
      trackFamilyMembersDeleteAll();
    } else {
      trackFamilyMembersChanged();
    }
    props.onMemberChange(props.index, e.target.value);
  },
  onRemove: props => () => {
    trackFamilyMembersRemove();
    props.onMemberChange(props.index);
  },
});

export default enhance(Member);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/FamilyMembers/Member/index.js